require('./commit-comments.spec')
require('./commits.spec')
require('./contents.spec')
require('./deployments.spec')
require('./downloads.spec')
require('./events.spec')
require('./gists.spec')
// require './gitignore.spec' This is already handled by simple
// require './hooks.spec' This is already handled by simple

require('./status.spec')
require('./stats.spec')
